import "@/App.css";
import { BrowserRouter, HashRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/layout/Layout";
import { ProtectedRoute } from "@/components/layout/ProtectedRoute";
import { IS_STATIC } from "@/lib/api";

// Static builds use HashRouter so deep links work on any static host (e.g. GoDaddy)
const Router = IS_STATIC ? HashRouter : BrowserRouter;

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Tracking from "@/pages/Tracking";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6" data-testid="notfound-page">
      <p className="font-heading font-extrabold text-7xl text-brand">404</p>
      <p className="mt-4 text-muted-foreground">The page you're looking for doesn't exist.</p>
      <Link to="/" className="mt-8 inline-flex items-center rounded-full bg-brand text-white px-6 py-3 font-semibold hover:bg-brand-deep transition-colors">
        Back to Home
      </Link>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/track" element={<Tracking />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          {!IS_STATIC && (
            <>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            </>
          )}
        </Routes>
      </Router>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
